import React, { useEffect, useState } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
//import { database } from "./firebase";
import { auth,database ,logout} from "./firebase";
import { getDatabase, ref, child, get,remove } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { reload } from 'firebase/auth';
import DateTime from './DateTime';

import "./i18n";
import { useTranslation } from "react-i18next";
import { FirebaseDBFileList2 } from './FirebaseDBFileList2';
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';


const db = getDatabase();


const FirebaseDB2 = () => {
  const [datas, setDatas] = useState([]);
  //const [user, setUser] = useState('');
  const [age, setAge] = useState('');
  const [num,setNum] = useState(0)

  //const userRef = database.ref('users');
  const userRef = ref(db);

  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  // const params = useParams().id;
  // console.log("test" + params);

  const [searchParams] = useSearchParams();

  
  var roomID = searchParams.get('id')
  console.log({lang: roomID}) 

  useEffect(() => {
    // userRef.on('value', snapshot => {
    //   const users = snapshot.val();
    //   const usersData = [];
    //   for(let id in users) {
    //     usersData.push({ ...users[id], id });
    //   }
  
    //   setDatas(usersData);
    // })

    if (loading) return;
    
    //if (!user) return navigate("/");

    var count = 0 
    var fileSize = 0
    console.log(`users/${user?.uid}/items`);

    get(child(userRef, `share/devices`)).then((snapshot) => {
      if (snapshot.exists()) {
        console.log(snapshot.val());
        const usersData = [];

        //setNum ( snapshot.count() )

        snapshot.forEach(function(d) {
          console.log(d.key);
          console.log(d.val());
          
          //setNum ( num +1 )
          count++
          


          var data = {key:d.key, user:d.val().deviceName ,
            state : 'offline',
            roomID:d.val().roomID,
            name:d.val().name,
            uid : d.val().uid,
            deviceID : d.val().deviceID,
            fileShow:false,
            updateDateTime:d.val().updateDateTime,
            url : d.val().url,
            youtube: d.val().youtube
          };

          
          
          if ( data.name == '56134140') {
            data.name = '다산고등학교'
          }

          var now = new Date()
          var update = new Date(d.val().updateDateTime)
          update.setSeconds(update.getSeconds() + 65 * 10)
          console.log(update);

          if(data.youtube && now < update ){
            data.state = "online"

            if(roomID != null){
              if( roomID == data.roomID)
                usersData.push(data);
            }else
              usersData.push(data);

              console.log(  d.val())

          }else{
            
          }

          // if( d.val().roomID != "0"){
          //   data.state = "online"
          // }

        })

        for(let d in snapshot.val()) {
        }
        
        setDatas(usersData);

      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      
      console.log(user?.uid);
      console.error(error);
    });

    
  }, [user, loading]);

  const onChange = (e) => {
    //e.target.name === 'user' ? setUser(e.target.value) : setAge(e.target.value);
  }

  const onClickAdd = () => {
    const userData = { user, age };

    userRef.push(userData);
    //setUser('');
    setAge('');
  }

  const onFileView = (data) => {
    

    data.fileShow = !data.fileShow

    setDatas(datas.map(el => el.key === data.key ? {...el, fileShow: data.fileShow} : el));

    // remove(child(userRef, `users/${user?.uid}/items/${id}`))
    // setDatas( datas.filter(el => el.key != id));
    //child(userRef, `users/${user?.uid}/items/${id}`).remove();
    //remove(ref(db, `users/${user?.uid}/items/${id}`))
    //userRef.child(id).remove();


  }

  function refreshPage() {
    window.location.reload(false);
  }
  

  const onUpdate = (id) => {
    const [user] = datas.filter(el => el.id === id);

    userRef.child(id).update({
      age: user.age++
    });

    setDatas(datas.map(el => el.id === id ? {...el, age: el.age++} : el));
  };

  const { t, i18n } = useTranslation();

  return (
    <div >
      <div>
        CCTV device : {datas.length} unit
      </div>

      {datas?.map(data => <div key={data.id}>
        <div style={{
          backgroundColor: data.roomID != "0"? 'green' : 'white'
      }}>
          {/* {t("device_id")} : {data.user}
          <br />
          {t("start_time")}: {data.startDateTime}
          <br />
          {t("update_time")} : {data.updateDateTime}
          <br />
          {t("time_zone")}: {data.timeZone}
          <br />
          {t("battery")} : {data.battery}
          <br /> */}
          <br />
          name : {data.name}

          <br />
          updateDateTime : {data.updateDateTime}
          <br />
          roomID : {data.roomID}
          <br />
          status : {data.state}
          <br />
          url : {data.url}
          <br />
          youtube : {data.youtube}
          
          {data.url && (
                <>
                  <br />
                  <iframe
                  width="560"
                  height="315"
                  src={"https://www.youtube.com/embed/"+data.url}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  ></iframe>
                </>
                )}

          {/* <button style={{marginLeft: '10px', height: '30px', width : '100px'}}  onClick={() => window.open("https://aihome.netlify.app/live?id="+data.roomID, "_blank")}>{t("home_link")}</button>  */}

        </div>
        <br />
        {/* <button style={{marginLeft: '10px', height: '60px', width : '200px'}}  onClick={() => window.open("https://androidtv.netlify.app/?id="+data.roomID, "_blank")}>{t("cctv_view")}</button>  */}
        
        <button style={{marginLeft: '10px',height: '60px', width : '200px'}} onClick={() => onFileView(data)}>{t("file_list")}</button>
        <hr />
        {
          
        }
        {
          data.fileShow && <FirebaseDBFileList2 uid={data.uid} deviceID={data.deviceID} ></FirebaseDBFileList2>
        }
         

      </div>
      )}

      {/* <input onChange={onChange} name='user' placeholder='user' value={user}></input>
      <input onChange={onChange} name='age' placeholder='age' value={age}></input>
      <button onClick={onClickAdd}>추가하기</button> */}

        {/* <button className="dashboard__btn" onClick={refreshPage}>
          Page Refresh(화면갱신)
        </button> */}


<br />
<br />
      <DateTime></DateTime>
      

    </div>
  );
};

//export default FirebaseDB;
export {FirebaseDB2};